/* eslint-disable */
import { useState } from "react";
import { Link } from "react-router-dom";
import { BreadcrumbCenter } from "../components/subcomponents/BreadcrumpCenter";
import { SocialShare } from "../components/subcomponents/Sharesocial";
import { routes } from "../utils/utils.routes";
import { ContactLink } from "../components/subcomponents/ContactComponent";
import { Hrseparator } from "../components/subcomponents/Hrseparator";
import { BreadcrumpComponent } from "../components/subcomponents/BreadcrumpCompont";
import hero from "../assets/images/image-asset.webp";
import { APPOWNER } from "../utils/utils.constants";
import { ProfileCard } from "../components/subcomponents/ProfileCard";
import { PageSectionHeader } from "../components/subcomponents/PageSectionHeader";
import { modalities, staffMembers } from "../utils/utils.statiquedata";

import { Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { LibraryDashboard } from "../components/Dashboardbibliotheque";
import { Colors } from "../utils/utils.colors";

const columns: ColumnsType<ReglePret> = [
    {
        title: '#',
        dataIndex: 'id',
        key: 'key',
        align: 'center',
        width: 60,
        fixed: "left"
    },
    {
        title: "Catégorie d'usagers",
        dataIndex: 'categorie',
        key: 'categorie',
        align: 'left',
    },
    {
        title: "Nombre d'ouvrages",
        dataIndex: 'nombre_ouvrages',
        key: 'nombre_ouvrages',
        align: 'center',
        width: 180,
    },
    {
        title: 'Durée du prêt',
        dataIndex: 'duree_pret',
        key: 'duree_pret',
        align: 'left',
        className: "bg-primary-table"
    },
];

export const Library = () => {
    const [item, setItem] = useState<StaffMember>(staffMembers[5]);

    return (
        <>
            <BreadcrumpComponent
                imageCover={hero}
                title={`Bibliothèque`}
                subtitle={"La bibliothèque développe une collection de ressources imprimées et électroniques adaptée aux besoins documentaires des étudiants"}
            />

            <div className="row page-content- mt-4 padding-x">
                <aside className="col-md-4 pe-md-5">
                    {/* <ProfileCard
                        profile={item}
                        showDescription={false}
                        variant="sidebar"
                    /> */}
                    <div className="content-detail__card">
                        <h3>Partage</h3>
                        <SocialShare
                            slug={"institut-metanoia"}
                            title={"Bibliothèque de l'ULPGL"}
                            description={"Découvrez la bibliothèque de l'ULPGL, un espace dédié à l'apprentissage et à la recherche. Explorez notre collection de ressources imprimées et électroniques, adaptée aux besoins des étudiants, enseignants et chercheurs. Profitez d'un environnement propice à l'étude et à la découverte."}
                        />
                    </div>

                    <div className="mt-5 pt-5">
                        <PageSectionHeader
                            eyebrow="Explorer"
                            title="Voir aussi"
                            size="compact"
                            align="start"
                        />
                        <ul className="list-unstyled detail-section__list">
                            <li className="mb-2">
                                <Link to={routes.METANOIA} className="text-decoration-none text-dark">
                                    Institut Metanoia
                                </Link>
                            </li>
                            <li className="mb-2">
                                <Link to={routes.KAUTA} className="text-decoration-none text-dark">
                                    Kauta
                                </Link>
                            </li>
                            <li className="mb-2">
                                <Link to={routes.KAUTA_MATERNEL} className="text-decoration-none text-dark">
                                    La Crèche
                                </Link>
                            </li>
                        </ul>
                    </div>
                </aside>

                <main className="col-md-8">
                    <article className="entry-content">

                        {/* Profile */}
                        <PageSectionHeader
                            eyebrow="Présentation"
                            title="Profil et collection documentaire"
                            size="compact"
                            align="start"
                        />
                        <p>
                            La bibliothèque développe une collection de ressources imprimées et électroniques adaptée aux besoins documentaires des étudiants,
                            enseignants- chercheurs et usagers désirant approfondir, développer, actualiser des connaissances disciplinaires,
                            scientifiques ou professionnelles. Le fonds documentaire est cohérent et actualisé dans les disciplines et leurs développements historiques, il propose pour celles-ci les titres fondamentaux et les sources principales
                        </p>
                        <hr className="my-4" style={{ opacity: 0.1 }} />
                        <PageSectionHeader eyebrow="Règlement" title="Modalités d'emprunt" size="compact" align="start" />
                        <Table
                            columns={columns}
                            dataSource={modalities}
                            pagination={false}
                            bordered
                            scroll={{ x: 'max-content' }}
                            size="middle"
                            components={{
                                header: {
                                    cell: (props: any) => (
                                        <th
                                            {...props}
                                            style={{
                                                ...props.style,
                                                background: Colors.primaryColor,
                                                color: Colors.whiteColor
                                            }}
                                        />
                                    )
                                }
                            }}
                        />
                        <hr className="my-4" style={{ opacity: 0.1 }} />
                        <PageSectionHeader
                            eyebrow="Ressources"
                            title="Informations générales et règlements"
                            lead="Tout ce qu'il faut savoir pour fréquenter et profiter de la bibliothèque de l'ULPGL."
                            size="compact"
                            align="start"
                        />
                        <LibraryDashboard />
                        {/* Direction */}
                        <hr className="my-4" style={{ opacity: 0.1 }} />
                        <PageSectionHeader eyebrow="Équipe" title="Direction" size="compact" align="start" />
                        <h6>Eliezer BISIMWA MWONGANE</h6>

                        {/* Contacts */}
                        <hr className="my-4" style={{ opacity: 0.1 }} />
                        <PageSectionHeader eyebrow="Contact" title="Contacts" size="compact" align="start" />
                        <ul>
                            <li><ContactLink value={"+243997775077"} /></li>
                            <li><ContactLink value={"eliezermwo@yahoo.fr"} /></li>
                        </ul>
                    </article>
                </main>
            </div>
            <Hrseparator />
        </>
    );
}